import { z } from 'zod'
import { requiredString } from './util'

export const AddressSchema = z.object({
  zip: requiredString.min(4, 'minLength.4'),
  city: requiredString.min(3, 'minLength.3'),
  street: requiredString.min(3, 'minLength.3'),
  street2: requiredString,
  country_code: requiredString,
  vat: z.string().optional(),
})

export const PartialAddressSchema = z.object({
  zip: z.string().nullable(),
  city: z.string().nullable(),
  street: z.string().nullable(),
  street2: z.string().nullish(),
  country_code: z.string(),
  vat: z.string().nullish(),
})

export const InvoiceSchema = AddressSchema.extend({
  firstName: requiredString,
  lastName: requiredString,
  vatId: z.string().optional(),
  type: z.literal('invoice'),
  email: z.union([z.string().email(), z.literal('')]),
  mobile: z.string().optional(),
  birth_date: z.string().nullable().catch(null),
})

export const InvoiceResponseSchema = InvoiceSchema.extend({
  id: z.number(),
  vatId: z.string().optional(),
})

export const InvoiceSchemaVat = InvoiceSchema.extend({
  vatId: requiredString,
})

export type Invoice = z.infer<typeof InvoiceSchema>
export type InvoiceResponse = z.infer<typeof InvoiceResponseSchema>

const CustomerAddressSchema = z.object({
  customer_id: z.string(),
  vat: z.string().nullable(),
  firstName: z.string(),
  lastName: z.string().nullable(),
  email: z.string().email().nullable(),
  phone: z.string().nullable(),
  address: AddressSchema,
  type: z.union([z.literal('invoice'), z.literal('shipping')]),
})

export const CustomerAddressCreateSchema = CustomerAddressSchema.extend({})
export const CustomerAddressPatchSchema = CustomerAddressSchema.partial()

export const CustomerAddressWithIdSchema = CustomerAddressSchema.extend({
  id: z.number(),
})
